import { render, staticRenderFns } from "./ModalSwitchVersion.vue?vue&type=template&id=1a04fa51&scoped=true&"
import script from "./ModalSwitchVersion.vue?vue&type=script&lang=js&"
export * from "./ModalSwitchVersion.vue?vue&type=script&lang=js&"
import style0 from "./ModalSwitchVersion.vue?vue&type=style&index=0&id=1a04fa51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a04fa51",
  null
  
)

export default component.exports